import { createSlice } from '@reduxjs/toolkit';

import { getSmeManualPaymentThunk } from '../../services/smeManaulPayment.service.ts/smeManualPaymentThunk';
import { AccountDetails } from '../collection/collectionSlice';

export type SmeManualPaymentData = {
  id: string;
  amount?: number;
  referenceNo?: string;
  channel?: string;
  bankName?: string;
  paymentDate?: string;
  loanType?: string;
  remark?: string;
  fileId?: string;
  createdBy?: string;
  createdAt?: string;
  updatedAt?: string;
  accountDetails: AccountDetails;
};

export type SmeManualPaymentUploadData = {
  agreementNo?: string;
  referenceNo?: string;
  status: 'failed' | 'success';
  error?: string;
};

export type SmeManualPaymentUploadResponse = {
  data: SmeManualPaymentUploadData[];
};

export type SmeManualPaymentDataResponse = {
  total: number;
  currentPage: number;
  pageSize: number;
  data: SmeManualPaymentData[];
};

export type SmeManualPaymentState = {
  smeManualPayment: {
    isLoading: boolean;
    isError: boolean;
    errorMessage: any;
    data: SmeManualPaymentDataResponse;
  };
  smeManualPaymentUpload: {
    isLoading: boolean;
    isError: boolean;
    errorMessage: any;
    data: SmeManualPaymentUploadResponse;
  };
};

const initialState: SmeManualPaymentState = {
  smeManualPayment: {
    isLoading: false,
    isError: false,
    errorMessage: '',
    data: {
      total: 0,
      currentPage: 0,
      pageSize: 0,
      data: [],
    },
  },
  smeManualPaymentUpload: {
    isLoading: false,
    isError: false,
    errorMessage: '',
    data: {
      data: [],
    },
  },
};

export const smeManualPayment = createSlice({
  name: 'smeManualPayment',
  initialState,
  reducers: {
    SmeManalPaymentStateReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSmeManualPaymentThunk.pending, (state) => {
        state.smeManualPayment.isLoading = true;
      })
      .addCase(getSmeManualPaymentThunk.fulfilled, (state, action) => {
        state.smeManualPayment.isLoading = false;
        state.smeManualPayment.data = action.payload;
      })
      .addCase(getSmeManualPaymentThunk.rejected, (state, action) => {
        state.smeManualPayment.isLoading = false;
        state.smeManualPayment.isError = true;
        state.smeManualPayment.errorMessage = action.payload;
      });
  },
});

export const { SmeManalPaymentStateReset } = smeManualPayment.actions;

export default smeManualPayment.reducer;
